import React from "react";
import { siteConfig } from "../siteConfig.js";

const PlayIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M3.18 23.76c.3.17.64.24.99.19L14.9 12 3.18.05A1.5 1.5 0 0 0 3 .72v22.56c0 .19.06.36.18.48z"/>
    <path d="M19.35 9.29 16.3 7.54 12.83 12l3.47 4.46 3.05-1.75A2 2 0 0 0 20.5 12a2 2 0 0 0-1.15-2.71z"/>
    <path d="M4.17.05 15.6 11.3 4.17 23.95l11-6.3L20.5 12 4.17.05z" opacity=".5"/>
  </svg>
);

export default function OurApp() {
  return (
    <div className="container section">
      <div className="pageHero">
        <div className="pageHeroText">
          <span className="eyebrow">The Rahisi App</span>
          <div className="pageHeroTitle">Your neighbourhood<br />store, in your pocket.</div>
          <p className="pageHeroSub">
            Rahisi is a free Android app that connects Kenyan shoppers with local retailers —
            fast delivery, real-time tracking, and M-Pesa payments built in.
          </p>
          <a
            className="playStoreBtn playStoreBtnDark"
            href={siteConfig.playStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginTop: "8px" }}
          >
            <PlayIcon />
            <div className="playStoreBtnInner">
              <span className="playStoreBtnSmall">GET IT ON</span>
              <span className="playStoreBtnLabel">Google Play</span>
            </div>
          </a>
        </div>
        <img src="/tablet_bg_6.png" alt="Rahisi app screens" style={{
          width: "220px", borderRadius: "16px", boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
          flexShrink: 0, objectFit: "cover",
        }} />
      </div>

      <div className="screenshotsGrid" style={{ gridTemplateColumns: "repeat(4,1fr)", marginBottom: "40px" }}>
        {[
          { img: "/tablet_bg_1.png", label: "Home & discovery" },
          { img: "/tablet_bg_2.png", label: "Product browsing" },
          { img: "/tablet_bg_3.png", label: "Flash deals" },
          { img: "/tablet_bg_4.png", label: "Cart & checkout" },
        ].map((s) => (
          <div className="screenshotCard" key={s.label}>
            <img src={s.img} alt={s.label} />
            <div className="screenshotLabel">{s.label}</div>
          </div>
        ))}
      </div>

      <div className="featuresGrid">
        {[
          { icon: "🛍️", title: "Browse & discover", desc: "Explore products across categories — groceries, electronics, fashion, and daily essentials from local sellers." },
          { icon: "🏷️", title: "Flash deals & promos", desc: "Time-limited deals with countdown timers. Promo codes redeemable at checkout for instant savings." },
          { icon: "📍", title: "Same-day delivery", desc: "Orders placed before 4 PM ship same day in Nairobi. Live map shows your rider's exact location." },
          { icon: "📱", title: "M-Pesa payments", desc: "Pay with M-Pesa STK push — a prompt appears on your phone, no manual entry needed." },
          { icon: "🔁", title: "Order history & returns", desc: "Full order history with status. 7-day return window for unused items, initiated in-app." },
          { icon: "🔔", title: "Smart notifications", desc: "Get notified on deals, order status, and delivery updates — only when it matters." },
        ].map((f) => (
          <div className="featureCard" key={f.title}>
            <div className="featureCardIcon">{f.icon}</div>
            <div className="featureCardTitle">{f.title}</div>
            <p className="featureCardDesc">{f.desc}</p>
          </div>
        ))}
      </div>

      <div className="ctaSection" style={{ marginTop: "48px" }}>
        <div className="ctaSectionText">
          <h2 className="ctaTitle">Download Rahisi free.</h2>
          <p className="ctaSubtitle">Available now on Android. Same-day delivery across Nairobi.</p>
        </div>
        <div className="ctaActions">
          <a
            className="playStoreBtn"
            href={siteConfig.playStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <PlayIcon />
            <div className="playStoreBtnInner">
              <span className="playStoreBtnSmall">GET IT ON</span>
              <span className="playStoreBtnLabel">Google Play</span>
            </div>
          </a>
          <span className="ctaNote">Free · Android · Kenya</span>
        </div>
      </div>

      <div className="prose" style={{ marginTop: "48px" }}>
        <h3 className="h3">Privacy and permissions</h3>
        <p>
          The Rahisi app requests only the permissions it needs: location (for delivery address and rider tracking),
          notifications (for order updates), and storage (for app function). We do not sell your data or share it
          with third parties beyond what is required to complete your order. Full details are in our{" "}
          <a href="/privacy">Privacy Policy</a>.
        </p>
      </div>
    </div>
  );
}
